/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Filter,
  HTTPValidationError,
  TransactionsPage,
  YearlyDistributionsResponse,
} from '../models/index';
import {
    FilterFromJSON,
    FilterToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    TransactionsPageFromJSON,
    TransactionsPageToJSON,
    YearlyDistributionsResponseFromJSON,
    YearlyDistributionsResponseToJSON,
} from '../models/index';

export interface GetTransactionsRequest {
    pageIndex?: number;
    pageSize?: number;
    sortLabel?: string;
    sortDesc?: boolean;
    filter?: Array<Filter>;
}

export interface GetYearlyDistributionsRequest {
    requestBody?: Array<string>;
}

/**
 * 
 */
export class TransactionApi extends runtime.BaseAPI {

    /**
     * Retrieve transactions with the specified filters.
     */
    async getTransactionsRaw(requestParameters: GetTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransactionsPage>> {
        const queryParameters: any = {};

        if (requestParameters.pageIndex !== undefined) {
            queryParameters['page_index'] = requestParameters.pageIndex;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.sortLabel !== undefined) {
            queryParameters['sort_label'] = requestParameters.sortLabel;
        }

        if (requestParameters.sortDesc !== undefined) {
            queryParameters['sort_desc'] = requestParameters.sortDesc;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/transaction`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.filter?.map(FilterToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransactionsPageFromJSON(jsonValue));
    }

    /**
     * Retrieve transactions with the specified filters.
     */
    async getTransactions(requestParameters: GetTransactionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransactionsPage> {
        const response = await this.getTransactionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve summed distributions (Withdrawals & Transfer Out) for the current year.
     */
    async getYearlyDistributionsRaw(requestParameters: GetYearlyDistributionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<YearlyDistributionsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/yearly-distributions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => YearlyDistributionsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve summed distributions (Withdrawals & Transfer Out) for the current year.
     */
    async getYearlyDistributions(requestParameters: GetYearlyDistributionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<YearlyDistributionsResponse> {
        const response = await this.getYearlyDistributionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Invalidate and update transactions cache
     */
    async invalidateTrnasactionsCacheRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/transactions-cache`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Invalidate and update transactions cache
     */
    async invalidateTrnasactionsCache(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.invalidateTrnasactionsCacheRaw(initOverrides);
        return await response.value();
    }

}
